function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "27.968,132.967 41.552,133.732 37.932,117.126 48.347,119.841 43.97,127.239 43.97,144.146  49.404,126.483 55.742,129.507 52.577,149.129 58.609,149.427 65.406,134.028 75.814,137.046 71.445,155.47 60.426,164.522  55.445,163.465 52.877,169.349 54.39,176.141 47.895,180.671 44.422,191.539 66.169,199.543 80.042,199.84 81.104,190.028  87.289,191.539 98.008,187.768 98.008,179.16 85.484,167.09 85.781,156.671 115.82,133.274 133.932,155.919 139.67,154.408  146.915,160.752 151.896,161.503 157.178,152.141 157.937,139.318 154.014,131.467 157.178,128.45 156.426,119.389 150.083,115.614  142.989,127.686 136.202,130.259 133.63,124.975 114.759,108.063 114.759,98.403 110.083,93.126 137.255,81.053 157.937,56.6  157.178,44.517 162.609,44.974 166.54,34.41 172.877,29.878 170.462,25.051 154.309,14.024 145.104,16.747 140.422,9.2  110.387,-0.16 95.141,2.858 104.355,21.276 103.292,37.73 89.708,39.693 62.538,36.221 51.822,51.765 44.73,55.841 43.67,73.955  38.991,73.955 32.648,80.601 28.268,97.955 "
});

var Svg32 = function Svg32(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ZAC",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg32, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/32.2bd0ad2e.svg";
export { ForwardRef as ReactComponent };